<template>
    <div class="filip_section">
        <div class="layer_parent_div">
            <button @click="setValue('left')" class="bcommon b1 active first">
                <img src="./icon/flip-1.png" />
            </button>
            <button @click="setValue('top')" class="bcommon b2 last">
                <img src="./icon/flip-2.png" />
            </button>
        </div>
        <label>Flip</label>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Flip",
    /* eslint-enable */
    props: ["value"],
    data: () => {
        return {};
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", e);
        },
        setActive(e) {
            return e == this.value ? "active" : "";
        }
    }
};
</script>

<style>
.layer_parent_div {
    display: flex;
    align-items: stretch;
    width: 100%;
    margin: 0px 15px;
}

.bcommon {
    background-color: initial;
    color: #7796a8;
    border: 1px solid;
    border-radius: 0 !important;
    background: #7796a8;
    width: 40px;
}

.b1 {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
}

.b2 {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}
</style>
